// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"2219359c","258":"e612ae2f","377":"acc7f5f5","417":"19ecb67a","467":"ceae46ee","626":"e5e40771","870":"3639219f"}[chunkId] + ".js";
};